<div class="notification-inner">
  <cue-icon [icon]="ICONS.cueCheckCircle" class="icon" />
  <div class="flex flex-column gap-1">
    <h2>{{ title() }}</h2>
    <p class="text">{{ text() }}</p>
  </div>
</div>

<h2></h2>
